/**
 * @generated SignedSource<<7d53e22f4385b0658d8bcc538f821071>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineIcon = "key" | "residual" | "shelf_hole" | "waste";
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type StoreAnalyticsScreenQuery$variables = {
  fromDate?: string | null;
};
export type StoreAnalyticsScreenQuery$data = {
  readonly store: {
    readonly id: string;
    readonly issueStats: {
      readonly " $fragmentSpreads": FragmentRefs<"IssueStatsCreatedGraph_IssueStats" | "IssueStatsTTRGraph_IssueStats" | "IssueStatsTopTypes_IssueStats">;
    };
    readonly kpis: ReadonlyArray<{
      readonly icon: RoutineIcon | null;
      readonly id: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"KPIStoreAnalytics_KPI">;
    }>;
    readonly todoCategories: ReadonlyArray<{
      readonly icon: TodoCategoryIcon | null;
      readonly id: string;
      readonly stats: {
        readonly " $fragmentSpreads": FragmentRefs<"TodoCountAnalytics_TodoStats">;
      } | null;
      readonly title: string;
    }>;
  };
};
export type StoreAnalyticsScreenQuery = {
  response: StoreAnalyticsScreenQuery$data;
  variables: StoreAnalyticsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fromDate"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = [
  (v5/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreAnalyticsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueStats",
            "kind": "LinkedField",
            "name": "issueStats",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueStatsTopTypes_IssueStats"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueStatsTTRGraph_IssueStats"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueStatsCreatedGraph_IssueStats"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KPI",
            "kind": "LinkedField",
            "name": "kpis",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "KPIStoreAnalytics_KPI"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoStats",
                "kind": "LinkedField",
                "name": "stats",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TodoCountAnalytics_TodoStats"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoreAnalyticsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueStats",
            "kind": "LinkedField",
            "name": "issueStats",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueStatTitleCountNode",
                "kind": "LinkedField",
                "name": "topIssueTitles",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "fromDate",
                    "variableName": "fromDate"
                  }
                ],
                "concreteType": "IssueTimeToResolveBucketed",
                "kind": "LinkedField",
                "name": "timeToResolveBucketed",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bucketTimeSeconds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "counts",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssuePerDateStat",
                "kind": "LinkedField",
                "name": "created",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssuePerDateStat",
                "kind": "LinkedField",
                "name": "resolved",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KPI",
            "kind": "LinkedField",
            "name": "kpis",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "KPISectionAggregate",
                "kind": "LinkedField",
                "name": "sectionAggregates",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeam",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "KPIAggregateResult",
                    "kind": "LinkedField",
                    "name": "results",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoStats",
                "kind": "LinkedField",
                "name": "stats",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoPerDateStat",
                    "kind": "LinkedField",
                    "name": "created",
                    "plural": true,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssuePerDateStat",
                    "kind": "LinkedField",
                    "name": "resolved",
                    "plural": true,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "41ad5757f7833625f886c541b4523e2e",
    "id": null,
    "metadata": {},
    "name": "StoreAnalyticsScreenQuery",
    "operationKind": "query",
    "text": "query StoreAnalyticsScreenQuery(\n  $fromDate: String\n) {\n  store {\n    id\n    issueStats {\n      ...IssueStatsTopTypes_IssueStats\n      ...IssueStatsTTRGraph_IssueStats\n      ...IssueStatsCreatedGraph_IssueStats\n      id\n    }\n    kpis {\n      id\n      title\n      icon\n      ...KPIStoreAnalytics_KPI\n    }\n    todoCategories {\n      id\n      title\n      icon\n      stats {\n        ...TodoCountAnalytics_TodoStats\n      }\n    }\n  }\n}\n\nfragment IssueStatsCreatedGraph_IssueStats on IssueStats {\n  created {\n    count\n    date\n  }\n  resolved {\n    count\n    date\n  }\n}\n\nfragment IssueStatsTTRGraph_IssueStats on IssueStats {\n  timeToResolveBucketed(fromDate: $fromDate) {\n    bucketTimeSeconds\n    counts\n    total\n  }\n}\n\nfragment IssueStatsTopTypes_IssueStats on IssueStats {\n  topIssueTitles {\n    title\n    count\n  }\n}\n\nfragment KPIStoreAnalytics_KPI on KPI {\n  id\n  title\n  unit\n  sectionAggregates {\n    section {\n      id\n      title\n      assignedTeam {\n        icon\n        color\n        name\n        id\n      }\n    }\n    results {\n      date\n      value\n    }\n  }\n}\n\nfragment TodoCountAnalytics_TodoStats on TodoStats {\n  created {\n    date\n    count\n  }\n  resolved {\n    date\n    count\n  }\n}\n"
  }
};
})();

(node as any).hash = "181539126be6e2489ba218d656c47f6d";

export default node;
